module.exports = __webpack_public_path__ + "static/media/2H.4f6b17f1.svg";